import { render, staticRenderFns } from "./EditAudience.vue?vue&type=template&id=55758854&scoped=true&"
import script from "./EditAudience.vue?vue&type=script&lang=ts&"
export * from "./EditAudience.vue?vue&type=script&lang=ts&"
import style0 from "./EditAudience.vue?vue&type=style&index=0&id=55758854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55758854",
  null
  
)

export default component.exports